import React, { Component } from "react";
import "./App.css";
import Navbar from "./Components/Navbar";
import WelcomeSection from "./Components/welcomeSection";
import AboutSection from "./Components/aboutSection";
import dummyText from "./DummyText";
import ProjectsSection from "./Components/ProjectsSection";
import ContactSection from "./Components/contactSection";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Navbar />
        <WelcomeSection />
        <AboutSection />
        <ProjectsSection />
        <ContactSection />
      </div>
    );
  }
}

export default App;
